import type { EcosystemHeadCorridorCardData } from "@/components/ecosystem-head/EcosystemHeadCorridorCard";
import { ecosystemHeadProfileHref } from "@/pages/ecosystem-heads/ecosystemHeads.const";
import type { SectorEcosystemCorridorHead } from "@shared/sectorEcosystemOverview";

export function formatJoinRequestSlotsLabel(args: {
  joinRequestLimit?: number | null;
  joinRequestRemaining?: number | null;
  joinRequestFull?: boolean;
}): string | null {
  if (args.joinRequestLimit == null) return null;
  const remaining = args.joinRequestRemaining ?? 0;
  if (args.joinRequestFull || remaining <= 0) return "No slots remaining";
  return remaining === 1 ? "1 slot remaining" : `${remaining} slots remaining`;
}

export function sectorCorridorToCardData(corridor: SectorEcosystemCorridorHead): EcosystemHeadCorridorCardData {
  return {
    id: corridor.ecosystemHeadUserId,
    name: corridor.name,
    corridorName: corridor.corridorName,
    managedCompanyCount: corridor.managedCompanyCount,
    ecosystemIndustry: corridor.industry,
    ecosystemCountry: corridor.country,
    ecosystemTargetCountry: corridor.targetCountry,
    corridorLabel: corridor.corridorLabel,
    expertiseTags: corridor.expertiseTags,
    focusSectors: corridor.focusSectors,
    ecosystemHeadSummary: corridor.ecosystemHeadSummary ?? null,
    ecosystemHeadLiveFrom: corridor.liveFrom ?? null,
    profileStatus: corridor.profileStatus,
    linkStatus: null,
    logoUrl: corridor.logoUrl ?? null,
    joinRequestLimit: corridor.joinRequestLimit ?? null,
    joinRequestUsed: corridor.joinRequestUsed,
    joinRequestRemaining: corridor.joinRequestRemaining ?? null,
    joinRequestFull: corridor.joinRequestFull,
  };
}

export function sectorCorridorProfileHref(corridor: SectorEcosystemCorridorHead): string {
  return ecosystemHeadProfileHref(corridor.industry, corridor.ecosystemHeadUserId);
}
